<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-select
          v-model="tableQuery.coachIdList" style="width: 180px;"
          filterable placeholder="请输入姓名"
          remote reserve-keyword :remote-method="selectCoach" clearable multiple collapse-tags>
        <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">
          {{coach.id}} - {{coach.name}}
        </el-option>
      </el-select>

      <el-cascader collapse-tags style="width: 200px;margin:0 10px" ref="cascaderRef"
                   :options="deptTree" v-model="tableQuery.deptList"
                   :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>

      <el-date-picker :clearable="false" v-model="tableQuery.date" type="month" value-format="yyyy-MM" style="width: 140px;" placeholder="选择月"/>

      <el-select v-model="tableQuery.isComplete" clearable placeholder="请选择分类" style="margin:0 10px;width: 140px;">
        <el-option label="计划表" :value="0"/>
        <el-option label="绩效表" :value="1"/>
      </el-select>

      <el-button type="danger" @click="selectPage(),statisticsPerformance()" style="margin-right: 10px">查询</el-button>
      <el-button-group v-if="user.deptName === '人事行政部'">
        <el-tooltip class="item" effect="dark" :content="exportList.length>0 ? '导出Excel文件！':'请先选择需要导出的行！'" placement="top">
          <el-button type="danger" @click="exportExcel">导出文件</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="导出绩效表的总得分！" placement="top">
          <el-button type="danger" @click="getPerformanceScoreExcel">导出总分</el-button>
        </el-tooltip>
      </el-button-group>


    </div>
    <el-table border class="table" :data="tableData"  height="600px" v-loading="tableQuery.loading" @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column property="id" label="ID"></el-table-column>
      <el-table-column property="coachName" label="老师"></el-table-column>
      <el-table-column property="deptName" label="所属部门"></el-table-column>
      <el-table-column property="addTime" label="计划提交时间">
        <template #default="scope">
          <div v-if="scope.row.statistics">
            {{scope.row.submitCount}}份
          </div>
          <div v-else>
            {{scope.row.addTime == null ? '待提交':scope.row.addTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="绩效提交时间">
        <template #default="scope">
          <div v-if="scope.row.statistics">
            {{scope.row.summaryCount}}份
          </div>
          <div v-else>
            {{scope.row.summaryTime == null ? '待提交':scope.row.summaryTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="绩效评分时间">
        <template #default="scope">
          <div v-if="scope.row.statistics">
            {{scope.row.scoringCount}}份
          </div>
          <div v-else>
            {{scope.row.targetCoachName}} - {{scope.row.scoringTime == null ? '待评分':scope.row.scoringTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template #default="scope">
          <div v-if="scope.row.statistics">
          </div>
          <div v-else>
            <el-button type="danger" size="mini" @click="selectDetails(scope.row.coachId),statisticsPerformance();">查 看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex;justify-content: space-between;align-items: center">
      <div style="display: flex;font-weight: bold">
        <el-button plain type="danger" style="border-radius: 8px;font-weight: bold">总人数：{{statistics.totalCount}}</el-button>
        <el-tooltip class="item" effect="dark" :content="'本月共计：'+statistics.submitCount+'份计划'" placement="top">
          <el-button plain type="danger" style="margin: 0 10px;border-radius: 8px;font-weight: bold">计划：{{statistics.submitCount}} 份</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="'本月共计：'+statistics.summaryCount+'份绩效'" placement="top">
          <el-button plain style="border-radius: 8px;font-weight: bold" type="danger">绩效：{{statistics.summaryCount}} 份</el-button>
        </el-tooltip>
      </div>
      <el-pagination
          style="text-align: right;margin: 20px 10px"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="tableQuery.pageSize"
          @current-change="selectPage"
          @size-change="currentPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableQuery.total">
      </el-pagination>
    </div>

    <el-dialog :title="personnelLookPerformance.type == 0 ? '计划汇总':'绩效汇总'" :visible.sync="personnelLookPerformanceDialog">
      <el-table :data="personnelLookPerformance.list" height="400px">
        <el-table-column property="deptName" label="部门"></el-table-column>
        <el-table-column property="notCount" label="没提交"></el-table-column>
        <el-table-column property="submitCount" label="提交的"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {selectCoach} from '/src/api/contacts/user'
import {selectDeptAndUserTree} from "../../../../api/contacts/dept";
import {selectPerformancePage,selectStatisticsPerformance,personnelLookPerformance,batchExportExcel,getPerformanceScoreExcel} from "../../../../api/performance/performance";
export default {
  name: "PerformanceList",
  data() {
    return {
      user:JSON.parse(localStorage.getItem("user")),
      deptTree:[],
      coachList:[],
      tableQuery:{
        pageIndex:0,
        pageSize:10,
        total:0,
        isComplete:null,
        date:null,
        loading:false,
        coachIdList:[],
        deptList:[],
        deptCoachIdList:[]
      },
      exportList:[],
      personnelLookPerformanceDialog:false,
      personnelLookPerformance:[],
      tableData:[],
      statistics:{}
    }
  },
  methods: {
    selectDetails(coachId){
      let item = {coachId,'year':this.tableQuery.year,'month':this.tableQuery.month};
      this.$router.push({
        path: "/admin/performance/selectPerformance",
        query: {item}
      });
    },
    currentPageSize(val){
      this.tableQuery.pageSize = val;
      this.selectPage();
    },
    handleSelectionChange(val){
      this.exportList = val;
    },
    exportExcel(){
      if (this.exportList.length<=0){
        this.$notify.warning({title: '警告', message: '请先选择需要导出的行数据！', offset: 40});return;
      }
      if (this.tableQuery.isComplete == null){
        this.$notify.warning({title: '警告', message: '请选择分类！', offset: 40});return;
      }
      const list = this.exportList.map(item => item?.coachId || null);
      let query = {'type':this.tableQuery.isComplete,'coachIdList':list};
      batchExportExcel(query).then(val=>{
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    getPerformanceScoreExcel(){
      this.tableQuery.loading = true;
      const date = this.tableQuery.date.split('-');
      this.tableQuery.year = date[0];
      this.tableQuery.month = date[1];
      this.coachDispose();
      getPerformanceScoreExcel(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    selectPage(val){
      if (val){
        this.tableQuery.pageIndex = val;
      }
      this.tableQuery.loading = true;
      const date = this.tableQuery.date.split('-');
      this.tableQuery.year = date[0];
      this.tableQuery.month = date[1];
      this.coachDispose();
      selectPerformancePage(this.tableQuery).then(val=>{
        if (val.status){
          this.tableData = val.data.list;
          this.tableQuery.loading = false;
          this.tableQuery.total = val.data.total;
        }
      })

    },
    statisticsPerformance(){
      selectStatisticsPerformance(this.tableQuery).then(val=>{
        if (val.status){
          this.statistics = val.data;
        }
      })
    },
    selectCoach(val){
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.coachList = val.data;
      })
    },
    /**
     * 处理选择的教练数据
     */
    coachDispose(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      if (ref != null){
        const checkedNodes = ref.getCheckedNodes();
        checkedNodes.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            list.push(node.value);
          }
        });
      }
      this.tableQuery.deptCoachIdList = list;
    },
  },
  created() {
    let date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    this.tableQuery.date = year+"-"+month;
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptTree=val.data;
      }
    })
    this.selectPage();
    this.statisticsPerformance();
    personnelLookPerformance().then(val=>{
      if (val.status == 200 && val.data.list.length>0){
        this.personnelLookPerformance=val.data;
        this.personnelLookPerformanceDialog = true;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 0px;
  height: 550px;
}
</style>